import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCard } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { dateFormat } from '../../../../../utilities/DateUtility';
import { environment } from '../../../../../../environments/environment';
import { UserContextProvider } from '../../../../../infrastructure/context/user-context-provider';
import { GuestService } from '../../../services/guest.service';
import { Reservation } from '../../../../reservations/models/Reservation';
import { BehaviorSubject } from 'rxjs';
import { Logger } from '../../../../../infrastructure/logging/logger';

@Component({
  selector: 'app-guest-detail-verification-email',
  templateUrl: './guest-detail-verification-email.component.html',
  styleUrls: ['./guest-detail-verification-email.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCard,
    MatFormFieldModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
    MatCheckboxModule,
    MatProgressSpinner
  ]
})
export class GuestDetailVerificationEmailComponent implements OnInit {

  @Input() guestId!: number;
  @Input() reservation?: Reservation;

  loading = new BehaviorSubject<boolean>(false);
  landingPageUrl?: string;
  reservationId?: number;
  updateToken?: string;
  tokenExpirationDate?: string;
  emailAddress?: string;
  saveEmailAddress?: boolean = true;

  dateFormat = dateFormat;

  constructor(
    private guestService: GuestService,
    private logService: Logger,
    private snackBar: MatSnackBar,
    public userContextProvider: UserContextProvider
  ) { }

  ngOnInit() {
    Promise
      .all([this.loadGuest()])
      .then(_ => this.buildLandingPageUrl());
  }

  buildLandingPageUrl() {
    this.landingPageUrl = `${environment.portalConfig.checkinPortalBasePath}/verification/update?token=${this.updateToken}&r=${this.reservation?.reservation_id}`;
  }

  async loadGuest() {
    this.loading.next(true);

    try {
      const guestDetails = await this.guestService.getGuestDetails(this.guestId);
      if (guestDetails) {
        this.updateToken = guestDetails.screening_token ?? guestDetails.update_token;
        this.reservationId = guestDetails.screening_reservation_id ? Number(guestDetails.screening_reservation_id) : this.reservationId;
        this.tokenExpirationDate = guestDetails.token_expired;
        this.emailAddress = guestDetails.email;
      }
    } catch(e) {
      this.logService.handleError(e, 'An error occurred while retrieving Guest details', `An error occurred while retrieving Guest details for ID: ${this.guestId}`);
    } finally {
      this.loading.next(false);
    }
  }

  sendEmail() {
    try {
      this.guestService.sendReminder(this.guestId, this.landingPageUrl || '', this.reservationId || 0, this.saveEmailAddress || false, 'Safely - Reminder', this.emailAddress || '');
      this.snackBar.open('Reminder email sent', 'OK', { duration: 3000 });
    } catch(e) {
      this.snackBar.open('Error while sending reminder email', 'OK', { duration: 3000 });
    }
  }
}